import {Pipe, PipeTransform} from "@angular/core";
import { IManagableObject } from "../../admin-panel/IManagableObject";
import { matchesSearchRule } from "./filterByProperty";

@Pipe({
    name: 'filterByName',
    pure: false,
    standalone: false
})
export class FilterByNamePipe implements PipeTransform
{
  transform(items: IManagableObject[], term: string): any
  {
    if (!items) return [];
    if (!term || term == "") return items;

    var res = [];
    for (let i = 0; i < items.length; i++)
      if (matchesSearchRule(items[i].Name, term))
        res.push(items[i]);
      //else
        //items[i].IsChecked = false;
    return res;
  }
}
